export interface BusinessPage {
  id: string;
  module: string;
  name: string;
  path: string;
  resource: string;
  hidden: boolean;
  ready: boolean;
}
export const modules = [
  {
    key: 'work',
    name: '工作台',
    icon: 'home',
  },
  {
    key: 'equipment',
    name: '设备与采集',
    icon: 'usb',
  },
  {
    key: 'records',
    name: '录音中心',
    icon: 'audio',
  },
  {
    key: 'intelligence',
    name: '智能分析',
    icon: 'bulb',
  },
  {
    key: 'verification',
    name: '核查与跟进',
    icon: 'safetyCertificate',
  },
  {
    key: 'learning',
    name: '教学与知识',
    icon: 'read',
  },
  {
    key: 'operations',
    name: '运营驾驶舱',
    icon: 'barChart',
  },
  {
    key: 'administration',
    name: '系统与服务',
    icon: 'setting',
  },
] as const;
export const businessPages: BusinessPage[] = [
  {
    id: 'W01',
    module: 'work',
    name: '我的工作台',
    path: '/workspace',
    resource: 'workspace',
    hidden: false,
    ready: true,
  },
  {
    id: 'W02',
    module: 'work',
    name: '我的任务',
    path: '/task',
    resource: 'task',
    hidden: false,
    ready: true,
  },
  {
    id: 'W03',
    module: 'work',
    name: '消息中心',
    path: '/message',
    resource: 'message',
    hidden: false,
    ready: true,
  },
  {
    id: 'W04',
    module: 'work',
    name: '全局搜索',
    path: '/search',
    resource: 'search',
    hidden: false,
    ready: true,
  },
  {
    id: 'D01',
    module: 'equipment',
    name: '设备总览',
    path: '/device/overview',
    resource: 'device',
    hidden: false,
    ready: true,
  },
  {
    id: 'D02',
    module: 'equipment',
    name: '设备台账',
    path: '/device',
    resource: 'device',
    hidden: false,
    ready: true,
  },
  {
    id: 'D03',
    module: 'equipment',
    name: '设备详情',
    path: '/device/:deviceUuid',
    resource: 'device',
    hidden: true,
    ready: true,
  },
  {
    id: 'D04',
    module: 'equipment',
    name: '领用归还调拨',
    path: '/device/assignment',
    resource: 'device',
    hidden: false,
    ready: true,
  },
  {
    id: 'D05',
    module: 'equipment',
    name: '型号与能力',
    path: '/device/model',
    resource: 'deviceModel',
    hidden: false,
    ready: true,
  },
  {
    id: 'D06',
    module: 'equipment',
    name: '配件与库存',
    path: '/device/inventory',
    resource: 'inventory',
    hidden: false,
    ready: true,
  },
  {
    id: 'D07',
    module: 'equipment',
    name: '故障与维修',
    path: '/device/repair',
    resource: 'repair',
    hidden: false,
    ready: true,
  },
  {
    id: 'C01',
    module: 'equipment',
    name: '采集控制台',
    path: '/collection',
    resource: 'collection',
    hidden: false,
    ready: true,
  },
  {
    id: 'C02',
    module: 'equipment',
    name: '采集站',
    path: '/collection/station',
    resource: 'collection',
    hidden: false,
    ready: true,
  },
  {
    id: 'C03',
    module: 'equipment',
    name: '批次详情',
    path: '/collection/batch/:batchUuid',
    resource: 'collection',
    hidden: true,
    ready: true,
  },
  {
    id: 'C04',
    module: 'equipment',
    name: '采集异常',
    path: '/collection/exception',
    resource: 'collection',
    hidden: false,
    ready: true,
  },
  {
    id: 'C05',
    module: 'equipment',
    name: '手动导入',
    path: '/collection/import',
    resource: 'collection',
    hidden: false,
    ready: true,
  },
  {
    id: 'R01',
    module: 'records',
    name: '录音档案',
    path: '/recording',
    resource: 'recording',
    hidden: false,
    ready: true,
  },
  {
    id: 'R02',
    module: 'records',
    name: '录音详情',
    path: '/recording/:recordingUuid',
    resource: 'recording',
    hidden: true,
    ready: true,
  },
  {
    id: 'R03',
    module: 'records',
    name: '收藏与标记',
    path: '/recording/bookmark',
    resource: 'recording',
    hidden: false,
    ready: true,
  },
  {
    id: 'R04',
    module: 'records',
    name: '待确认关联',
    path: '/recording/pending-link',
    resource: 'recording',
    hidden: false,
    ready: true,
  },
  {
    id: 'A01',
    module: 'intelligence',
    name: '分析任务',
    path: '/analysis/job',
    resource: 'analysis',
    hidden: false,
    ready: true,
  },
  {
    id: 'A02',
    module: 'intelligence',
    name: '结果详情',
    path: '/analysis/result/:resultUuid',
    resource: 'analysis',
    hidden: true,
    ready: true,
  },
  {
    id: 'A03',
    module: 'intelligence',
    name: '分析模板',
    path: '/analysis/template',
    resource: 'analysisTemplate',
    hidden: false,
    ready: true,
  },
  {
    id: 'A04',
    module: 'intelligence',
    name: '质量评估',
    path: '/analysis/evaluation',
    resource: 'evaluation',
    hidden: false,
    ready: true,
  },
  {
    id: 'V01',
    module: 'verification',
    name: '线索中心',
    path: '/review/clue',
    resource: 'clue',
    hidden: false,
    ready: true,
  },
  {
    id: 'V02',
    module: 'verification',
    name: '复核工作台',
    path: '/review/clue/:clueUuid',
    resource: 'clue',
    hidden: true,
    ready: true,
  },
  {
    id: 'V03',
    module: 'verification',
    name: '事项列表',
    path: '/case',
    resource: 'case',
    hidden: false,
    ready: true,
  },
  {
    id: 'V04',
    module: 'verification',
    name: '事项详情',
    path: '/case/:caseUuid',
    resource: 'case',
    hidden: true,
    ready: true,
  },
  {
    id: 'V05',
    module: 'verification',
    name: '更正与复议',
    path: '/review/correction',
    resource: 'correction',
    hidden: false,
    ready: true,
  },
  {
    id: 'S01',
    module: 'verification',
    name: '学生服务档案',
    path: '/student/:studentUuid',
    resource: 'student',
    hidden: true,
    ready: true,
  },
  {
    id: 'S02',
    module: 'verification',
    name: '服务跟进',
    path: '/service/follow-up',
    resource: 'service',
    hidden: false,
    ready: true,
  },
  {
    id: 'S03',
    module: 'verification',
    name: '反馈草稿',
    path: '/service/feedback',
    resource: 'feedback',
    hidden: false,
    ready: true,
  },
  {
    id: 'T01',
    module: 'learning',
    name: '教学分析总览',
    path: '/teaching/overview',
    resource: 'teaching',
    hidden: false,
    ready: true,
  },
  {
    id: 'T02',
    module: 'learning',
    name: '课程与课次',
    path: '/teaching/lesson',
    resource: 'teaching',
    hidden: false,
    ready: true,
  },
  {
    id: 'T03',
    module: 'learning',
    name: '课堂详情',
    path: '/teaching/lesson/:lessonUuid',
    resource: 'teaching',
    hidden: true,
    ready: true,
  },
  {
    id: 'T04',
    module: 'learning',
    name: '教师成长档案',
    path: '/teacher/:memberUuid',
    resource: 'teacher',
    hidden: true,
    ready: true,
  },
  {
    id: 'T05',
    module: 'learning',
    name: '教师目录',
    path: '/teaching/teacher',
    resource: 'teacher',
    hidden: false,
    ready: true,
  },
  {
    id: 'T06',
    module: 'learning',
    name: '改进计划',
    path: '/teaching/plan',
    resource: 'plan',
    hidden: false,
    ready: true,
  },
  {
    id: 'K01',
    module: 'learning',
    name: '案例与方法库',
    path: '/knowledge',
    resource: 'knowledge',
    hidden: false,
    ready: true,
  },
  {
    id: 'K02',
    module: 'learning',
    name: '案例详情',
    path: '/knowledge/:knowledgeUuid',
    resource: 'knowledge',
    hidden: true,
    ready: true,
  },
  {
    id: 'K03',
    module: 'learning',
    name: '案例编辑',
    path: '/knowledge/:knowledgeUuid/edit',
    resource: 'knowledge',
    hidden: true,
    ready: true,
  },
  {
    id: 'K04',
    module: 'learning',
    name: '教研审核',
    path: '/knowledge/review',
    resource: 'knowledgeReview',
    hidden: false,
    ready: true,
  },
  {
    id: 'L01',
    module: 'equipment',
    name: '位置总览',
    path: '/location',
    resource: 'location',
    hidden: false,
    ready: true,
  },
  {
    id: 'L02',
    module: 'equipment',
    name: '轨迹查询',
    path: '/location/track',
    resource: 'location',
    hidden: false,
    ready: true,
  },
  {
    id: 'L03',
    module: 'equipment',
    name: '区域与围栏',
    path: '/location/zone',
    resource: 'location',
    hidden: false,
    ready: true,
  },
  {
    id: 'O01',
    module: 'operations',
    name: '集团驾驶舱',
    path: '/operation/group',
    resource: 'operation',
    hidden: false,
    ready: true,
  },
  {
    id: 'O02',
    module: 'operations',
    name: '校区运营',
    path: '/operation/campus',
    resource: 'operation',
    hidden: false,
    ready: true,
  },
  {
    id: 'O03',
    module: 'operations',
    name: '试点管理',
    path: '/pilot',
    resource: 'pilot',
    hidden: false,
    ready: true,
  },
  {
    id: 'O04',
    module: 'operations',
    name: '试点详情',
    path: '/pilot/:pilotUuid',
    resource: 'pilot',
    hidden: true,
    ready: true,
  },
  {
    id: 'O05',
    module: 'operations',
    name: '成本与用量',
    path: '/operation/usage',
    resource: 'usage',
    hidden: false,
    ready: true,
  },
  {
    id: 'H01',
    module: 'administration',
    name: '服务工单',
    path: '/support/ticket',
    resource: 'ticket',
    hidden: false,
    ready: true,
  },
  {
    id: 'H02',
    module: 'administration',
    name: '帮助与培训',
    path: '/support/help',
    resource: 'help',
    hidden: false,
    ready: true,
  },
  {
    id: 'G01',
    module: 'administration',
    name: '组织与人员',
    path: '/system/organization',
    resource: 'organization',
    hidden: false,
    ready: true,
  },
  {
    id: 'G02',
    module: 'administration',
    name: '业务角色与权限',
    path: '/system/permission',
    resource: 'permission',
    hidden: false,
    ready: true,
  },
  {
    id: 'G03',
    module: 'administration',
    name: '规则中心',
    path: '/system/rule',
    resource: 'rule',
    hidden: false,
    ready: true,
  },
  {
    id: 'G04',
    module: 'administration',
    name: '模型与处理配置',
    path: '/system/model',
    resource: 'model',
    hidden: false,
    ready: true,
  },
  {
    id: 'G05',
    module: 'administration',
    name: '接口与同步',
    path: '/system/integration',
    resource: 'integration',
    hidden: false,
    ready: true,
  },
  {
    id: 'G06',
    module: 'administration',
    name: '数据管理',
    path: '/system/data',
    resource: 'dataPolicy',
    hidden: false,
    ready: true,
  },
  {
    id: 'G07',
    module: 'administration',
    name: '审计日志',
    path: '/system/audit',
    resource: 'audit',
    hidden: false,
    ready: true,
  },
  {
    id: 'G08',
    module: 'administration',
    name: '产品与服务配置',
    path: '/system/subscription',
    resource: 'subscription',
    hidden: false,
    ready: true,
  },
];
export const moduleMenus = () =>
  modules.map((module) => ({
    path: `/module/${module.key}`,
    name: module.name,
    icon: module.icon,
    children: businessPages
      .filter((page) => page.module === module.key && !page.hidden)
      .map((page) => ({
        path: page.path,
        name: page.ready ? page.name : `${page.name} · 待开发`,
        disabled: !page.ready,
      })),
  }));
export const resolvePage = (pathname: string) =>
  [...businessPages]
    .sort((a, b) => Number(a.path.includes(':')) - Number(b.path.includes(':')))
    .find((page) =>
      new RegExp(`^${page.path.replace(/:[^/]+/g, '[^/]+')}$`).test(pathname),
    );

// Keep module paths as menu grouping keys; links resolve to an authorized business page.
export function moduleLanding(
  moduleKey: string,
  permitted: (page: BusinessPage) => boolean = () => true,
) {
  const pages = businessPages.filter(
    (page) =>
      page.module === moduleKey &&
      !page.hidden &&
      page.ready &&
      permitted(page),
  );
  return (
    pages.find((page) => moduleKey === 'verification' && page.id === 'S02') ||
    pages[0]
  )?.path;
}

export function activeMenuKeys(pathname: string) {
  const page = resolvePage(pathname);
  if (!page) return [];
  const fallback: Record<string, string> = {
    S01: '/service/follow-up',
    T04: '/teaching/teacher',
    A02: '/analysis/job',
    C03: '/collection',
  };
  const menuPath = page.hidden
    ? fallback[page.id] ||
      businessPages
        .filter(
          (p) =>
            !p.hidden &&
            p.module === page.module &&
            pathname.startsWith(`${p.path}/`),
        )
        .sort((a, b) => b.path.length - a.path.length)[0]?.path
    : page.path;
  return [
    `/module/${page.module}`,
    menuPath || moduleLanding(page.module) || '',
  ].filter(Boolean);
}

// Mix split menus must resolve a visible parent for hidden object routes.
export function layoutMenuPath(pathname: string) {
  return activeMenuKeys(pathname)[1] || pathname;
}
